import(/* webpackMode: "eager" */ "/app/components/ContactCards/PropertyContactCard.jsx");
import(/* webpackMode: "eager" */ "/app/components/CurrencySymbol.js");
import(/* webpackMode: "eager" */ "/app/components/Footers/FooterDefault.js");
import(/* webpackMode: "eager" */ "/app/components/Forms/EnquiryForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/HtmlComponent.jsx");
import(/* webpackMode: "eager" */ "/app/components/LinkComponent.js");
import(/* webpackMode: "eager" */ "/app/components/Location.jsx");
import(/* webpackMode: "eager" */ "/app/components/Nav.jsx");
import(/* webpackMode: "eager" */ "/app/components/ProjectInfoCard.jsx");
import(/* webpackMode: "eager" */ "/app/components/PropertyContact.jsx");
import(/* webpackMode: "eager" */ "/app/components/PropertyGalleryBlock.jsx");
import(/* webpackMode: "eager" */ "/app/components/RecommendedProperties.js");
import(/* webpackMode: "eager" */ "/app/components/ShareButton.js");
import(/* webpackMode: "eager" */ "/app/components/VideoComponent.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")